/**
 * Formato de teléfonos y de valores de datos personales.
 *
 * Módulo PURO a propósito: sin `fetch`, sin acciones, sin nada del navegador. Lo
 * importa `investigadores-public-adapter.ts`, que corre también en el servidor y
 * cuya cabecera exige mantenerse libre de dependencias de cliente; si esto viviera
 * en `datos-personales.ts` arrastraría `apiClient` y el cliente de revalidación
 * hacia el bundle del servidor.
 */

/** Código de catálogo del teléfono. Estable: es el contrato con la BD. */
export const TELEFONO_CODIGO = 'telefono';

/**
 * Deja un teléfono chileno como se escribe acá: `+56 9 1234 5678`.
 *
 * Formatea MIENTRAS se escribe y también antes de guardar, así lo que se ve en el
 * campo es exactamente lo que queda en la base — y las vistas no tienen que saber
 * nada de formatos.
 *
 * Lo que NO reconoce lo devuelve TAL CUAL: es preferible no tocar un número que no
 * se entiende a devolverlo mal.
 */
export function formatearTelefonoChile(valor: string): string {
	const digitos = valor.replace(/\D/g, '');
	if (digitos.length === 0) return '';

	const nacional = digitos.startsWith('56') ? digitos.slice(2) : digitos;
	// Más de 9 dígitos no es un número chileno.
	if (nacional.length > 9) return valor;

	// Celular (9 + 8 dígitos): se arma mientras se teclea, que es el caso normal.
	if (nacional.startsWith('9')) {
		return ['+56', nacional.slice(0, 1), nacional.slice(1, 5), nacional.slice(5, 9)]
			.filter(Boolean)
			.join(' ');
	}

	// Fijo: sólo cuando está completo. A medio escribir no se sabe dónde corta el
	// código de área, y agrupar de más mientras se teclea desordena el campo.
	if (nacional.length === 9) {
		return `+56 ${nacional.slice(0, 2)} ${nacional.slice(2, 5)} ${nacional.slice(5)}`;
	}

	return valor;
}

/**
 * Formatea el valor de un dato personal para MOSTRARLO. Hoy sólo el teléfono
 * necesita tratamiento; el resto pasa intacto.
 *
 * Va en el punto donde se arma la lista (el adaptador público y `EditShell`) y no
 * en cada componente que la pinta: así el perfil, el modo edición, el modal y la
 * exportación muestran lo mismo sin que cada uno tenga que acordarse.
 */
export function formatearDatoPersonal(codigo: string, valor: string): string {
	return codigo === TELEFONO_CODIGO ? formatearTelefonoChile(valor) : valor;
}
